// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
	CancelPurchaseData,
	CancelPurchaseErrors,
	CancelPurchaseResponses,
	CreatePurchaseData,
	CreatePurchaseErrors,
	CreatePurchaseResponses,
	FindMostRelevantTicketData,
	FindMostRelevantTicketErrors,
	FindMostRelevantTicketResponses,
	GetActiveOperatorTicketsData,
	GetActiveOperatorTicketsErrors,
	GetActiveOperatorTicketsResponses,
	GetOperatorData,
	GetOperatorErrors,
	GetOperatorResponses,
	GetOperatorTicketDetailData,
	GetOperatorTicketDetailErrors,
	GetOperatorTicketDetailResponses,
	GetTariffData,
	GetTariffErrors,
	GetTariffResponses,
	GetTicketData,
	GetTicketDetailData,
	GetTicketDetailErrors,
	GetTicketDetailResponses,
	GetTicketErrors,
	GetTicketResponses,
	ListMyTicketsData,
	ListMyTicketsErrors,
	ListMyTicketsResponses,
	ListOperatorsData,
	ListOperatorsErrors,
	ListOperatorsResponses,
	ListTariffsData,
	ListTariffsErrors,
	ListTariffsResponses,
	ListTicketsData,
	ListTicketsErrors,
	ListTicketsResponses,
	ListZonesData,
	ListZonesErrors,
	ListZonesResponses,
	SearchStopsData,
	SearchStopsErrors,
	SearchStopsResponses,
	SendInvoicesData,
	SendInvoicesErrors,
	SendInvoicesResponses,
} from './types.gen';

export type Options<
	TData extends TDataShape = TDataShape,
	ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

export const createPurchase = <ThrowOnError extends boolean = true>(
	options: Options<CreatePurchaseData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CreatePurchaseResponses,
		CreatePurchaseErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/purchases',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const cancelPurchase = <ThrowOnError extends boolean = true>(
	options: Options<CancelPurchaseData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CancelPurchaseResponses,
		CancelPurchaseErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/purchases/{purchaseId}/cancel',
		...options,
	});
};

/**
 * E-mail all paid invoices of a purchase to the passenger, one PDF per invoice
 */
export const sendInvoices = <ThrowOnError extends boolean = true>(
	options: Options<SendInvoicesData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		SendInvoicesResponses,
		SendInvoicesErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/me/tickets/{purchaseId}/invoices',
		...options,
	});
};

export const listTickets = <ThrowOnError extends boolean = true>(
	options?: Options<ListTicketsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		ListTicketsResponses,
		ListTicketsErrors,
		ThrowOnError
	>({
		url: '/api/v1/tickets',
		...options,
	});
};

export const getTicket = <ThrowOnError extends boolean = true>(
	options: Options<GetTicketData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetTicketResponses,
		GetTicketErrors,
		ThrowOnError
	>({
		url: '/api/v1/tickets/{ticketId}/tariff/{tariffId}',
		...options,
	});
};

export const listTariffs = <ThrowOnError extends boolean = true>(
	options?: Options<ListTariffsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		ListTariffsResponses,
		ListTariffsErrors,
		ThrowOnError
	>({
		url: '/api/v1/tariffs',
		...options,
	});
};

export const getTariff = <ThrowOnError extends boolean = true>(
	options: Options<GetTariffData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetTariffResponses,
		GetTariffErrors,
		ThrowOnError
	>({
		url: '/api/v1/tariffs/{tariffId}',
		...options,
	});
};

export const listZones = <ThrowOnError extends boolean = true>(
	options: Options<ListZonesData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		ListZonesResponses,
		ListZonesErrors,
		ThrowOnError
	>({
		url: '/api/v1/tariffs/{tariffId}/zones',
		...options,
	});
};

export const listOperators = <ThrowOnError extends boolean = true>(
	options?: Options<ListOperatorsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		ListOperatorsResponses,
		ListOperatorsErrors,
		ThrowOnError
	>({
		url: '/api/v1/operators',
		...options,
	});
};

export const getOperator = <ThrowOnError extends boolean = true>(
	options: Options<GetOperatorData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetOperatorResponses,
		GetOperatorErrors,
		ThrowOnError
	>({
		url: '/api/v1/operators/{operatorId}',
		...options,
	});
};

export const getActiveOperatorTickets = <ThrowOnError extends boolean = true>(
	options: Options<GetActiveOperatorTicketsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetActiveOperatorTicketsResponses,
		GetActiveOperatorTicketsErrors,
		ThrowOnError
	>({
		url: '/api/v1/operators/{operatorId}/tickets',
		...options,
	});
};

export const getOperatorTicketDetail = <ThrowOnError extends boolean = true>(
	options: Options<GetOperatorTicketDetailData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetOperatorTicketDetailResponses,
		GetOperatorTicketDetailErrors,
		ThrowOnError
	>({
		url: '/api/v1/operators/{operatorId}/tickets/{ticketId}',
		...options,
	});
};

export const searchStops = <ThrowOnError extends boolean = true>(
	options: Options<SearchStopsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		SearchStopsResponses,
		SearchStopsErrors,
		ThrowOnError
	>({
		url: '/api/v1/operators/{operatorId}/stops',
		...options,
	});
};

export const listMyTickets = <ThrowOnError extends boolean = true>(
	options?: Options<ListMyTicketsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		ListMyTicketsResponses,
		ListMyTicketsErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/me/tickets',
		...options,
	});
};

export const getTicketDetail = <ThrowOnError extends boolean = true>(
	options: Options<GetTicketDetailData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetTicketDetailResponses,
		GetTicketDetailErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/me/tickets/{purchaseId}',
		...options,
	});
};

export const findMostRelevantTicket = <ThrowOnError extends boolean = true>(
	options?: Options<FindMostRelevantTicketData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		FindMostRelevantTicketResponses,
		FindMostRelevantTicketErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v1/me/tickets/next',
		...options,
	});
};
